import React from 'react'
import {
  PlayerCardStyle,
  PlayerInfoCon,
  PlayerNameYearsCon,
  PlayerProfileCon,
  PlayerDetails,
  PlayerMeta,
  PlayerHeader,
  PlayerNameAccoladeCon,
  PlayerTeam,
  ProfilePlaceholder,
} from '../styles'
import { getTeamIc } from '../../../../../Utils'
import { Img } from '../../../../../Components/Image/Img'
import { PlayerDataGQL } from 'Api'

type PlayerProps = {
  playerInfo: PlayerDataGQL | null
  condensed?: boolean
}

export const WLLPlayerItem: React.FC<React.PropsWithChildren<PlayerProps>> = ({
  playerInfo,
  condensed = false,
}) => {
  if (!playerInfo) return null

  return (
    <PlayerCardStyle condensed={condensed}>
      <PlayerInfoCon>
        <PlayerHeader>
          <PlayerMeta>
            {playerInfo?.jerseyNum !== null && (
              <span>#{playerInfo.jerseyNum}</span>
            )}
          </PlayerMeta>
          <PlayerProfileCon>
            {playerInfo.profileUrl ? (
              <Img src={playerInfo.profileUrl} alt={`${playerInfo.name} Profile`} />
            ) : (
              <ProfilePlaceholder />
            )}
          </PlayerProfileCon>
          <PlayerMeta>
            <span>{playerInfo.position}</span>
          </PlayerMeta>
        </PlayerHeader>
        <PlayerDetails>
          <PlayerNameAccoladeCon>
            {playerInfo.currentTeam?.fullName && (
              <PlayerTeam>
                <Img
                  src={getTeamIc(playerInfo.currentTeam.fullName)}
                  alt={playerInfo.currentTeam.fullName}
                />
              </PlayerTeam>
            )}
            <PlayerNameYearsCon>
              <h3>{playerInfo.name}</h3>
            </PlayerNameYearsCon>
          </PlayerNameAccoladeCon>
        </PlayerDetails>
      </PlayerInfoCon>
    </PlayerCardStyle>
  )
}
